<template>
  <div class="Research">
    <div class="content">
      <div class="cont_box">
        <img src="@/assets/images/research3.png" />
        <div class="cont_box_rt">
          <div class="kyfx_title">
            <b
              >{{ $i18n.t("kyjz38") }}
              <span></span>
            </b>
          </div>
          <div class="cont_box_rt_title">{{ $i18n.t("kyjz4") }}</div>
          <div class="cont_box_rt1">{{ $i18n.t("kyjz5") }}</div>
        </div>
      </div>
      <div class="cont_box1">
        <div class="cont_box1_lt">
          <div class="kyfx_title">
            <b
              >{{ $i18n.t("kyjz39") }}

              <span></span
            ></b>
          </div>
          <div class="cont_box_rt_title">{{ $i18n.t("kyjz2") }}</div>
          <div class="cont_box_rt1">{{ $i18n.t("kyjz3") }}</div>
        </div>
        <img src="@/assets/images/research2.png" />
      </div>

      <div class="zzcbTitle">{{ $i18n.t("kyjz6") }}</div>
      <div class="zzcb" @mouseover="hadleOver" @mouseleave="handleLeave">
        <vue-seamless-scroll
          :data="items"
          :class-option="options"
          class="seamless-wrap"
        >
          <div class="zzcbItem" v-for="(item, index) in items" :key="index">
            <img :src="item.url" />
            <div class="zzcbItemTitle">{{ item.title }}</div>
          </div>
        </vue-seamless-scroll>
      </div>
      <div class="zzcbLine">
        <div :style="{ width: lineWidth + '%' }" class="lineBack"></div>
      </div>
      <div class="lwfb">
        <div class="lwfbTitle" @click="changeIndex(0)">
          {{$t('kyjz18')}} <b v-if="activeIndex == 0"></b>
        </div>
        <span>|</span>
        <div class="lwfbTitle" @click="changeIndex(1)">
          {{$t('kyjz19')}}
          <b v-if="activeIndex == 1"></b>
        </div>
      </div>
      <div v-if="activeIndex == 0" class="lwfbBt">
        <p @click="goPage(1)">
          [1]Y. Chen, L. Wang, Y. Ai, B. Jiao and L. Hanzo, "Performance
          Analysis of NOMA-SM in Vehicle-to-Vehicle Massive MIMO Channels," in
          IEEE Journal on Selected Areas in Communications, vol. 35, no. 12, pp.
          2653-2666, Dec. 2017, doi: 10.1109/JSAC.2017.2726006.
        </p>
        <p @click="goPage(2)">
          [2]M. Wen, X. Cheng, M. Ma, B. Jiao and H. V. Poor, "On the Achievable
          Rate of OFDM With Index Modulation," in IEEE Transactions on Signal
          Processing, vol. 64, no. 8, pp. 1919-1932, April15, 2016, doi:
          10.1109/TSP.2015.2500880.
        </p>
        <p @click="goPage(3)">
          [3]R. Zhang, X. Cheng, L. Yang and B. Jiao, "Interference Graph-Based
          Resource Allocation (InGRA) for D2D Communications Underlaying
          Cellular Networks," in IEEE Transactions on Vehicular Technology, vol.
          64, no. 8, pp. 3844-3850, Aug. 2015, doi: 10.1109/TVT.2014.2356198.
        </p>
        <p @click="goPage(4)">
          [4]Y. Bian, X. Cheng, M. Wen, L. Yang, H. V. Poor and B. Jiao,
          "Differential Spatial Modulation," in IEEE Transactions on Vehicular
          Technology, vol. 64, no. 7, pp. 3262-3268, July 2015, doi:
          10.1109/TVT.2014.2348791.
        </p>
        <p @click="goPage(5)">
          [5]R. Zhang, X. Cheng, L. Yang, X. Shen and B. Jiao, "A Novel
          Centralized TDMA-Based Scheduling Protocol for Vehicular Networks," in
          IEEE Transactions on Intelligent Transportation Systems, vol. 16, no.
          1, pp. 411-416, Feb. 2015, doi: 10.1109/TITS.2014.2335746.
        </p>
        <p @click="goPage(6)">
          [6]X. Shen, X. Cheng, L. Yang, R. Zhang and B. Jiao, "Data
          Dissemination in VANETs: A Scheduling Approach," in IEEE Transactions
          on Intelligent Transportation Systems, vol. 15, no. 5, pp. 2213-2223,
          Oct. 2014, doi: 10.1109/TITS.2014.2313631.
        </p>
        <p @click="goPage(7)">
          [7]H. Cui, M. Ma, L. Song and B. Jiao, "Relay Selection for Two-Way
          Full Duplex Relay Networks With Amplify-and-Forward Protocol," in IEEE
          Transactions on Wireless Communications, vol. 13, no. 7, pp.
          3768-3777, July 2014, doi: 10.1109/TWC.2014.2322607.
        </p>
        <p @click="goPage(8)">
          [8]H. Cui, L. Song and B. Jiao, "Multi-Pair Two-Way
          Amplify-and-Forward Relaying with Very Large Number of Relay
          Antennas," in IEEE Transactions on Wireless Communications, vol. 13,
          no. 5, pp. 2636-2645, May 2014, doi: 10.1109/TWC.2014.032514.130885.
        </p>
        <p @click="goPage(9)">
          [9]A. Huang et al., "WE-CARE: An Intelligent Mobile Telecardiology
          System to Enable mHealth Applications," in IEEE Journal of Biomedical
          and Health Informatics, vol. 18, no. 2, pp. 693-702, March 2014, doi:
          10.1109/JBHI.2013.2279136.
        </p>
        <p @click="goPage(10)">
          [10]M. Zhou, H. Cui, L. Song and B. Jiao, "Transmit-Receive Antenna
          Pair Selection in Full Duplex Systems," in IEEE Wireless
          Communications Letters, vol. 3, no. 1, pp. 34-37, February 2014, doi:
          10.1109/WCL.2013.110713.130711.
        </p>
        <p @click="goPage(11)">
          [11]Z. Zhao, X. Cheng, M. Wen, B. Jiao and C. -X. Wang, "Channel
          Estimation Schemes for IEEE 802.11p Standard," in IEEE Intelligent
          Transportation Systems Magazine, vol. 5, no. 4, pp. 38-49, winter
          2013, doi: 10.1109/MITS.2013.2270032.
        </p>
        <p @click="goPage(12)">
          [12]R. Zhang, X. Cheng, Q. Yao, C. -X. Wang, Y. Yang and B. Jiao,
          "Interference Graph-Based Resource-Sharing Schemes for Vehicular
          Networks," in IEEE Transactions on Vehicular Technology, vol. 62, no.
          8, pp. 4028-4039, Oct. 2013, doi: 10.1109/TVT.2013.2245156.
        </p>
        <p @click="goPage(13)">
          [13]X. Cheng, Q. Yao, M. Wen, C. -X. Wang, L. -Y. Song and B. -L.
          Jiao, "Wideband Channel Modeling and Intercarrier Interference
          Cancellation for Vehicle-to-Vehicle Communication Systems," in IEEE
          Journal on Selected Areas in Communications, vol. 31, no. 9, pp.
          434-448, September 2013, doi: 10.1109/JSAC.2013.SUP.0513039.
        </p>
        <p @click="goPage(14)">
          [14]C. Xu et al., "Efficiency Resource Allocation for Device-to-Device
          Underlay Communication Systems: A Reverse Iterative Combinatorial
          Auction Based Approach," in IEEE Journal on Selected Areas in
          Communications, vol. 31, no. 9, pp. 348-358, September 2013, doi:
          10.1109/JSAC.2013.SUP.0513031.
        </p>
        <p @click="goPage(15)">
          [15]T. Wang, L. Song, Z. Han and B. Jiao, "Dynamic Popular Content
          Distribution in Vehicular Networks using Coalition Formation Games,"
          in IEEE Journal on Selected Areas in Communications, vol. 31, no. 9,
          pp. 538-547, September 2013, doi: 10.1109/JSAC.2013.SUP.0513048.
        </p>
        <p @click="goPage(16)">
          [16]R. Zhang, L. Song, Z. Han and B. Jiao, "Physical Layer Security
          for Two-Way Untrusted Relaying With Friendly Jammers," in IEEE
          Transactions on Vehicular Technology, vol. 61, no. 8, pp. 3693-3704,
          Oct. 2012, doi: 10.1109/TVT.2012.2209692.
        </p>
        <p @click="goPage(17)">
          [17]X. Cheng et al., "Cooperative MIMO Channel Modeling and Multi-Link
          Spatial Correlation Properties," in IEEE Journal on Selected Areas in
          Communications, vol. 30, no. 2, pp. 388-396, February 2012, doi:
          10.1109/JSAC.2012.120218.
        </p>
        <p @click="goPage(18)">
          [18]J. Chen, R. Zhang, L. Song, Z. Han and B. Jiao, "Joint Relay and
          Jammer Selection for Secure Two-Way Relay Networks," in IEEE
          Transactions on Information Forensics and Security, vol. 7, no. 1, pp.
          310-320, Feb. 2012, doi: 10.1109/TIFS.2011.2166386.
        </p>
        <p @click="goPage(19)">
          [19]M. Ma, X. Huang, B. Jiao and Y. J. Guo, "Optimal Orthogonal
          Precoding for Power Leakage Suppression in DFT-Based Systems," in IEEE
          Transactions on Communications, vol. 59, no. 3, pp. 844-853, March
          2011, doi: 10.1109/TCOMM.2011.121410.100071.
        </p>
        <p @click="goPage(20)">
          [20]Y. Yang and B. Jiao, "Information-guided channel-hopping for high
          data rate wireless communication," in IEEE Communications Letters,
          vol. 12, no. 4, pp. 225-227, April 2008, doi:
          10.1109/LCOMM.2008.071986.
        </p>
      </div>
      <div v-if="activeIndex == 1" class="lwfbBt zlcg">
        <p>{{ $i18n.t("kyjz20") }}</p>
        <p>{{ $i18n.t("kyjz21") }}</p>
        <p>{{ $i18n.t("kyjz22") }}</p>
        <p>{{ $i18n.t("kyjz23") }}</p>
        <p>{{ $i18n.t("kyjz24") }}</p>
        <p>{{ $i18n.t("kyjz25") }}</p>
        <p>{{ $i18n.t("kyjz26") }}</p>
        <p>{{ $i18n.t("kyjz27") }}</p>
        <p>{{ $i18n.t("kyjz28") }}</p>
        <p>{{ $i18n.t("kyjz29") }}</p>
        <p>{{ $i18n.t("kyjz30") }}</p>
        <p>{{ $i18n.t("kyjz31") }}</p>
        <p>{{ $i18n.t("kyjz32") }}</p>
        <p>{{ $i18n.t("kyjz33") }}</p>
        <p>{{ $i18n.t("kyjz34") }}</p>
        <p>{{ $i18n.t("kyjz35") }}</p>
        <p>{{ $i18n.t("kyjz36") }}</p>
        <p>{{ $i18n.t("kyjz37") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import i18n from "@/lang/i18n";
export default {
  name: "Research",
  components: { vueSeamlessScroll },

  data() {
    return {
      timer: null,
      items: [
        {
          url: require("@/assets/images/research.png"),
          title: i18n.t("kyjz7"),
        },
        {
          url: require("@/assets/images/research4.png"),
          title: i18n.t("kyjz9"),
        },
        // {
        //   url: require("@/assets/images/research5.png"),
        //   title: i18n.t("kyjz11"),
        // },
        {
          url: require("@/assets/images/research6.png"),
          title: i18n.t("kyjz14"),
        },
        {
          url: require("@/assets/images/research7.png"),
          title: i18n.t("kyjz16"),
        },
      ],
      activeIndex: 0,
      lineWidth: 2,
      lineNum: 1,
    };
  },
  computed: {
    options() {
      return {
        direction: 3, // 0向下 1向左 2向上 3向右
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量
        hoverStop: true, // 是否开启鼠标悬停stop
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 2/3
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 1/3
        waitTime: 100, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  created() {
    this.creatInterval();
  },
  methods: {
    handleLeave() {
      this.creatInterval();
    },
    hadleOver() {
      clearInterval(this.timer);
      this.timer = null;
    },
    creatInterval() {
      this.timer = setInterval(() => {
        this.lineNum++;
        this.lineWidth = 2 * this.lineNum;
        if (this.lineNum >= 50) {
          this.lineNum = 0;
        }
      }, 1000);
    },
    goPage(type) {
      this.$router.push({
        path: "/Research/Researchinfo",
        query: {
          type: type,
        },
      });
    },
    changeIndex(index) {
      this.activeIndex = index;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>
<style lang="scss" scoped>
.Research {
  padding-bottom: 100px;
  background: url("../assets/images/kyjz2.png") no-repeat;
}
.content {
  margin-top: 70px;
}
.cont_box {
  overflow: hidden;
  margin-bottom: 112px;
}
.cont_box img {
  float: left;
  width: 750px;
  max-width: 50%;
  height: 460px;
  margin-right: 100px;
}
.cont_box .cont_box_rt {
  margin-left: 100px;
  height: 460px;
  display: flex;
  align-content: center;
  flex-wrap: wrap;
}
.cont_box_rt1 {
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  width: 100%;
  line-height: 36px;
}
.cont_box_rt_title {
  width: 100%;
  margin-bottom: 30px;
  font-weight: 400;
  font-size: 50px;
  color: #ffffff;
}
.content p {
  font-size: 16px;
  color: #fff;
  margin: 20px 0;
}
.box_item img {
  width: 750px;
  height: 460px;
  float: left;
}

.cont_box1 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 112px;
}
.cont_box1 img {
  float: right;
  margin-left: 100px;
  max-width: 50%;
}
.cont_box1_lt {
  float: left;
  display: flex;
  height: 460px;
  align-content: center;
  flex-wrap: wrap;
}
.zzcbTitle {
  width: 100%;
  font-weight: 500;
  font-size: 60px;
  color: #ffffff;
  margin-bottom: 63px;
}
.zzcb {
  width: 100%;
  overflow: hidden;
  height: 450px;
}
.zzcbItem {
  width: 285px;
  float: left;
  height: 450px;
  position: relative;
}
.zzcbItem img {
  float: left;
  width: 285px;
  height: 380px;
}
.zzcbItemTitle {
  width: 100%;
  text-align: left;
  font-size: 21px;
  position: absolute;
  left: 0;
  top: 390px;
}
.zzcbLine {
  width: 100%;
  height: 6px;
  background: #ffffff;
  border-radius: 3px;
  opacity: 0.32;
  margin-top: 48px;
}
.lineBack {
  width: 20%;
  height: 6px;
  border-radius: 3px;
  background: #5a93ff;
}
.lwfb {
  width: 100%;
  margin-top: 127px;
}
.lwfbBt {
  margin-top: 42px;
}
.lwfbBt p {
  cursor: pointer;
}
.lwfb span {
  font-weight: 500;
  font-size: 36px;
  color: #ffffff;
  margin: 0 66px;
}
.lwfbTitle {
  font-weight: 500;
  display: inline-block;
  font-size: 36px;
  cursor: pointer;
  color: #ffffff;
}
.lwfbTitle b {
  display: block;
  width: 100%;
  height: 5px;
  background: #920307;
  margin-top: 15px;
}
.zlcg p {
  cursor: auto;
}
.seamless-wrap > div {
  width: 100% !important;
}
.kyfx_title {
  position: relative;
  width: 100%;
  margin-bottom: 24px;
  b {
    font-size: 30px;
    color: #fff;
    position: relative;
    z-index: 333;
  }
  span {
    display: inline-block;
    width: 100%;
    height: 20px;
    background: #920307;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -1;
  }
}
</style>